module.exports = __webpack_public_path__ + "media/site_templates/www.tradesmennearme.com.au/images/testimonials-1dc9fb1fd0fd35997417e413fb57e955.jpg";